import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonSpinner,
  IonTitle,
  IonToolbar,
  useIonViewWillLeave,
} from "@ionic/react";
import Lightning from "assets/icons/Lightning";
import {
  eyeOffOutline,
  eyeOutline,
  informationCircleOutline,
} from "ionicons/icons";
import React, { useContext, useState } from "react";
import { useHistory } from "react-router";
import { AuthContext } from "../../contexts/AuthContext";
import "./Login.css";

const LoginForm = () => {
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const [viewPassword, setViewPassword] = useState(false);
  const {
    userEmail,
    userPassword,
    handleUserEmail,
    handleUserPassword,
    login,
    errorMessage,
    loading,
    setErrorMessage,
    setSuccessMessage,
  } = authContext;

  useIonViewWillLeave(() => {
    setSuccessMessage("");
    setErrorMessage("");
  });

  return (
    <IonPage className={"login-page-root"}>
      <IonContent fullscreen>
        <div className={"parent-container"}>
          <div className={"inner-container"}>
            <IonHeader className={"fixed-header ion-hide-md-up"}>
              <IonToolbar>
                <IonButtons slot="start">
                  <IonButton
                    onClick={() =>
                      history.push("/register", { direction: "back" })
                    }
                    color="dark"
                  >
                    <Lightning height={32} />
                  </IonButton>
                </IonButtons>
                <IonTitle>Sign in with Oshi</IonTitle>
              </IonToolbar>
            </IonHeader>
            <IonHeader collapse="condense" className={"dynamic-header"}>
              <div className={"logo-container ion-hide-md-down"}>
                <Lightning height={32} />
              </div>
              <IonToolbar>
                <IonTitle size="large">Sign in</IonTitle>
              </IonToolbar>
            </IonHeader>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                login();
              }}
            >
              <IonList lines="none">
                <IonItem className="bordered">
                  <IonLabel position="floating">Email address</IonLabel>
                  <IonInput
                    name="email"
                    type="email"
                    value={userEmail}
                    onIonChange={(e) => handleUserEmail(e)}
                  />
                </IonItem>
                <IonItem className="bordered">
                  <IonLabel position="floating">Password</IonLabel>
                  <IonInput
                    name="password"
                    type={viewPassword ? "text" : "password"}
                    value={userPassword}
                    onIonChange={(e) => handleUserPassword(e)}
                  />
                  <IonIcon
                    onClick={() => setViewPassword(!viewPassword)}
                    icon={viewPassword ? eyeOutline : eyeOffOutline}
                    slot="end"
                  />
                </IonItem>
                {errorMessage && (
                  <IonItem className={"error-message"}>
                    <IonIcon
                      slot="start"
                      icon={informationCircleOutline}
                      size="small"
                      color="danger"
                    />
                    <IonLabel color="danger">{errorMessage}</IonLabel>
                  </IonItem>
                )}

                <IonButton
                  disabled={loading}
                  expand="block"
                  color="primary"
                  onClick={() => login()}
                >
                  {loading ? <IonSpinner name="crescent" /> : "Sign in"}
                </IonButton>
                <IonItem
                  className={"forgot-password"}
                  routerLink={"/register"}
                  detail={false}
                >
                  <IonLabel>
                    <i>New to Oshi? Sign up.</i>
                  </IonLabel>
                </IonItem>
                <IonItem
                  className={"forgot-password"}
                  routerLink={"/forgot-password"}
                  detail={false}
                >
                  <IonLabel>Forgot Password?</IonLabel>
                </IonItem>
              </IonList>
            </form>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default LoginForm;
